// ========================================================
// FAST HIT Website — Entry Point
// ========================================================

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Core Design System CSS
import './styles/variables.css';
import './styles/index.css';
import './styles/components.css';
import './styles/utilities.css';

import { App } from './App';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container missing in index.html');
}

const root = createRoot(container);
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
